import {
  collection,
  doc,
  FirestoreDataConverter,
  Timestamp,
} from "firebase/firestore";
import { FirestoreSemanticData } from "reedy-data/models";

import { db } from "integrations/firebase/firestore";

export const SEMANTIC_DATA_COLLECTION = "semanticData";

export type SemanticData = FirestoreSemanticData;

type SemanticDataFromFirebase = Omit<
  SemanticData,
  "receivedAt" | "createdAt" | "updatedAt"
> & {
  // The receiver writes both on every result, so only updatedAt can be absent.
  receivedAt: Timestamp;
  createdAt: Timestamp;
  updatedAt: Timestamp | null;
};

const semanticDataConverter: FirestoreDataConverter<SemanticData> = {
  toFirestore(semanticData) {
    // biome-ignore lint/correctness/noUnusedVariables: drops id before the document is written to Firestore
    const { id, ...rest } = semanticData;
    return rest;
  },
  fromFirestore(snapshot) {
    const data = snapshot.data() as SemanticDataFromFirebase;
    return {
      ...data,
      receivedAt: data.receivedAt.toDate(),
      createdAt: data.createdAt.toDate(),
      updatedAt: data.updatedAt?.toDate() ?? null,
      id: snapshot.id,
    };
  },
};

export const getSemanticDataCollection = () =>
  collection(db, SEMANTIC_DATA_COLLECTION).withConverter(semanticDataConverter);

export const getSemanticDataDocument = (id: string) =>
  doc(getSemanticDataCollection(), id);
